import React from 'react';
import PropTypes from 'prop-types';

import SimpleComment from './SimpleComment';

const RepliesPreview = props =>
    (<div className='replies-list'>
        {
            props.comment.replies.length > 1 &&
                <span className='more-replies' data-what='more-replies-btn'>
                    { `${props.comment.replies.length - 1} ${gettext('more replies')}` }
                </span>
        }
        <SimpleComment
            comment={props.comment.replies[props.comment.replies.length - 1]}
        >
            <div className='reply-text'>
                {
                    props.commentsStore.resource.exists
                        ? props.commentsStore.canComment
                            ? gettext('Reply...')
                            : gettext('Please sign in to post replies.')
                        : gettext('Restore the resource to be able to post replies.')
                }
            </div>
        </SimpleComment>
    </div>);

export default RepliesPreview;

RepliesPreview.propTypes = {
    comment: PropTypes.object,
    commentsStore: PropTypes.object.isRequired
};
